export type ClassValue = string | false | null | undefined | 0;

/** Joins truthy class names. Class strings are always written literally so Tailwind can scan them. */
export function cn(...classes: ClassValue[]): string {
  return classes.filter(Boolean).join(" ");
}
